<div
  [formGroup]="form"
  *ngIf="form.get('selectedRequestNature')?.value === RequestNatureOptions.Attestation">
  <div class="w-full">
    <div class="relative mt-4 md:mt-0 mb-2">
      <label
        for="attestationType"
        class="block">
        {{ "contactUsForm.attestationType.label" | translate }}
        <span class="text-red opacity-60">*</span>
      </label>
      <p-dropdown
        [options]="attestationOptions"
        optionLabel="shortLabel"
        optionValue="code"
        formControlName="selectedAttestationType"
        [placeholder]="'contactUsForm.attestationType.placeholder' | translate"
        class="mt-1 block w-full border border-1 rounded-md shadow-sm"
        inputId="attestationType"
        [panelStyle]="{ width: '100%' }"
        [styleClass]="'relative w-full'"
        appendTo="body"
        (onChange)="updateAttestationTrame()">
        <ng-template pTemplate="dropdownicon">
          <i class="pi pi-chevron-down absolute right-2 top-1/2 transform -translate-y-1/2"></i>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  <div
    class="w-full"
    *ngIf="form.get('selectedAttestationType')?.value">
    <div class="relative mt-4 md:mt-0 mb-2">
      <label
        for="isAttestationFor"
        class="block">
        {{ "contactUsForm.isAttestationFor.label" | translate }}
        <span class="text-red opacity-60">*</span>
      </label>
      <p-dropdown
        [options]="isGeneratedOptions"
        optionLabel="label"
        optionValue="value"
        formControlName="isAttestationFor"
        [placeholder]="'contactUsForm.isAttestationFor.placeholder' | translate"
        class="mt-1 block w-full border border-1 rounded-md shadow-sm"
        inputId="isAttestationFor"
        [panelStyle]="{ width: '100%' }"
        [styleClass]="'relative w-full'"
        appendTo="body"
        (onChange)="updateAttestationTrame()">
        <ng-template pTemplate="dropdownicon">
          <i class="pi pi-chevron-down absolute right-2 top-1/2 transform -translate-y-1/2"></i>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
</div>
